export default {
    cn: {
        spreadCommissionMappingReport: {
            spreadCommission: '加点设定',
            th: {
                symbol: '货币对',
                Commission: '佣金(每10个点)',
                lastUpdate: '最后更新时间',
                operate: '操作',
                add: '添加',
                remove: '删除',
                save: '保存',
            },
            confirmDeleteText: '确定删除这条记录吗？',
            placeholder: '请选择',
            submitResult: {
                err: '请正确填写信息',
                succeed: '保存成功'
            }
        }
    },
    hk: {
        spreadCommissionMappingReport: {
            spreadCommission: '加點設定',
            th: {
                symbol: '貨幣對',
                Commission: '佣金(每10個點)',
                lastUpdate: '最后更新時間',
                operate: '操作',
                add: '添加',
                remove: '刪除',
                save: '保存',
            },
            confirmDeleteText: '確定刪除這條記錄嗎？',
            placeholder: '請選擇',
            submitResult: {
                err: '請正確填寫信息',
                succeed: '保存成功'
            },
        }
    },
    en: {
        spreadCommissionMappingReport: {
            spreadCommission: 'Spread Commission Setting',
            th: {
                symbol: 'Symbol',
                Commission: 'Commission (10 Points per USD)',
                lastUpdate: 'Last Update',
                operate: 'Operation',
                add: 'Add',
                remove: 'Remove',
                save: 'Save',
            },
            confirmDeleteText: 'Are you sure to delete this record?',
            placeholder: 'Please Choose',
            submitResult: {
                err: 'Please fill in the information correctly',
                succeed: 'Save Successsfully'
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/spreadCommissionMappingReport.js